/** RecordConversation — embed panel for 360 pages.
 *  Drop this into Asset 360 / Employee 360 / Request 360 etc. to expose a
 *  contextual conversation tied to that record.  Props:
 *    contextType  "asset" | "employee" | "request" | "shipment" | "invoice" …
 *    contextId    The record id.
 *    contextLabel Human-readable label shown at the top of the drawer.
 */
import { useState } from "react";
import { MessageSquare } from "lucide-react";
import { ChatDrawer } from "@/components/app/ChatDrawer";

export default function RecordConversation({ contextType, contextId, contextLabel }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid={`record-conversation-${contextType}-${contextId}`}
        className="st-btn st-btn-secondary"
      >
        <MessageSquare className="h-3.5 w-3.5" strokeWidth={1.6} />
        Discuss
      </button>
      {open && (
        <ChatDrawer
          onClose={() => setOpen(false)}
          contextType={contextType}
          contextId={contextId}
          contextLabel={contextLabel}
        />
      )}
    </>
  );
}
